import {useBannerList} from "./useBannerList";
import {BannerUnderHeader} from "./BannerUnderHeader";
import "./banners.scss"

export const Banners = () => {
    const {
        bannerList,
        setBannerClose,
        loading
    } = useBannerList()

    if (loading) {
        return <></>
    }

    return (
        <div>
            {bannerList.length > 0 && <BannerUnderHeader
                id={bannerList[0].id}
                text={bannerList[0].text}
                ctaUrl={bannerList[0].cta_url}
                ctaName={bannerList[0].cta_text}
                closeBanner={() => setBannerClose(+bannerList[0].id)}
            />}
        </div>
    )
}